import * as Yup from 'yup';
import i18n from '../../translation/config';

const codeValidationSchema = () =>
  Yup.object().shape({
    code: Yup.lazy((value) => {
      if (value !== undefined) {
        return Yup.string().test('codigo', i18n.t('code-must-be-4-characters'), (code) => code?.length === 4);
      }
      return Yup.mixed().notRequired();
    }),
  });

export default codeValidationSchema;
